/* eslint-disable @typescript-eslint/camelcase */
import React, { createContext, useContext } from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/styles';

import useGridButtonSize, { GridButtonSize } from './useGridButtonSize';

export const colors = {
  grid_green: '#37AF59',
  grid_light: '#C2E1F3',
  grid_dark: '#3998CE',
} as const;

const Context = createContext({
  classes: null as ClassNameMap | null,
});

const useStyles = makeStyles<Theme, GridButtonSize>(theme => ({
  gridButton: {
    borderRadius: theme.shape.borderRadius,
    height: props => props.height,
    width: props => props.width,
    fontSize: props => props.fontSize,
    fontWeight: 400,
    lineHeight: '1.23',
    color: '#232323 !important',
    margin: `0 4px 8px 4px`,
    padding: '2px 4px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    borderStyle: 'none !important',
    outline: 'none !important',
    position: 'relative',
  },
  ...Object.keys(colors).reduce((styles, color) => {
    // eslint-disable-next-line no-param-reassign
    styles[`gridButton-${color}`] = {
      background: colors[color],
      '&:hover': {
        background: `${colors[color]} !important`,
        filter: 'saturate(1.25) brightness(0.85) !important',
      },
      '&:focus, &:active': {
        background: `${colors[color]} !important`,
        filter: 'saturate(1.25) !important',
      },
      '&:disabled': {
        color: 'rgba(0, 0, 0, 0.45) !important',
        background: `${colors[color]} !important`,
        filter: 'grayscale(0.25) brightness(0.8) !important',
      },

      transition:
        'filter 50ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 50ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 50ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    };
    return styles;
  }, {}),
}));

export function useGridButtonStyles() {
  return useContext(Context);
}

export function GridButtonSizeProvider({ children }) {
  const gridButtonProps = useGridButtonSize();
  const gridButtonClasses = useStyles(gridButtonProps);
  return (
    <Context.Provider value={{ classes: gridButtonClasses }}>
      {children}
    </Context.Provider>
  );
}
